<template>
  <div>
    <button class="button" @click="$emit('page-selected',1)">1</button>
    <button class="button" @click="$emit('page-selected',2)">2</button>
    <button class="middle-button button">...</button>
  </div>
</template>

<script>
export default {
  props: {
    curPage: Number
  }
};
</script>